/** member_company 模块开启时才展示并校验公司字段 */
export function isMemberCompanyModuleEnabled(openornot?: string | null): boolean {
  return openornot === '1';
}
